import CircularProgress from '@mui/material/CircularProgress'
import { CampaignFilters } from 'components/molecules/CampaignFilters/index.tsx'
import { NoCampaignsYetTemplate } from 'components/templates/noCampaignsYetTemplate/index.tsx'
import { NoFilterCampaignResult } from 'components/templates/NoSearchResult'
import { useState } from 'react'
import { appSelectors } from 'redux/reducers/app.ts'
import { useAppSelector } from 'shared/hooks/store.ts'
import { useMount, useUnMount } from 'shared/hooks/useMount.ts'

// Actions
import { app } from '../../actions/app.js'
import { campaign } from '../../actions/campaign.js'
import { filters } from '../../actions/filters.js'
import { LinkedInNotLogged } from '../../components/molecules/linkedInNotLogged/LinkedInNotLogged.tsx'
import PersonalCampaignsStatistics from '../../components/molecules/personalCampaignsStatistics/index.js'
// Components
import { HomeTemplate } from '../../components/templates/homeTemplate'
import { campaignsSelectors } from '../../redux/reducers/campaigns.ts'

export function CampaignsPage() {
	const [campaignsLoading, setCampaignsLoading] = useState(false)

	const [orderby] = useState('created desc')

	const [page, setPage] = useState(0)

	const campaigns = useAppSelector(state => state.campaigns.campaigns),
		connector = useAppSelector(appSelectors.connector),
		error = useAppSelector(state => state.app.errorRequest.campaigns),
		filterQuery = useAppSelector(campaignsSelectors.filterQuery),
		haveCampaigns = useAppSelector(state => state.campaigns.haveCampaigns),
		isSearchOrFilterApplied = useAppSelector(
			campaignsSelectors.isFilterOrSearchActive
		),
		leftSide = useAppSelector(state => state.leftSideMenu.leftSide),
		pageContentLoader = useAppSelector(state => state.app.pageContentLoader),
		searchValue = useAppSelector(state => state.campaigns.searchValue)

	useMount(() => {
		firstLoad()
	})

	async function firstLoad() {
		app.changePageContentLoaderStatus(true)
		setCampaignsLoading(true)

		try {
			filters.clearAllFilters(true)
			filters.changeFilterQuery('', false)
			app.changePage('/campaigns')
			app.changeActiveItem(1)

			// TODO: Replace fetch campaign to RTK Query
			await filters.getCampaigns({
				archived: false,
				filter: filterQuery,
				keywords: searchValue,
				orderby
			})

			await campaign.getRecentCampaigns()
		} finally {
			setCampaignsLoading(false)
			app.changePageContentLoaderStatus(false)
		}
	}

	useUnMount(() => {
		connector.eventHandlers.removeAutomationEndedEventHandlers()
	})

	const hasLeftItems = Boolean(leftSide.list?.length)

	return (
		<HomeTemplate id='campaigns'>
			<LinkedInNotLogged />
			{(pageContentLoader || campaignsLoading) && (
				<div className='material-loader-wrapper'>
					<CircularProgress
						classes={{ colorPrimary: 'material-loader' }}
						color='primary'
						size={60}
					/>
				</div>
			)}

			{!haveCampaigns && !error && !hasLeftItems ? (
				<NoCampaignsYetTemplate />
			) : (
				<>
					{/*<HeaderTemplate labelName="All Campaigns" />*/}
					<CampaignFilters orderby={orderby} setPage={setPage} />

					{campaigns.length === 0 && !error && isSearchOrFilterApplied ? (
						<NoFilterCampaignResult />
					) : (
						<PersonalCampaignsStatistics
							orderby={orderby}
							// setOrderby={setOrderby}
							setTableCampaignsStatisticsPage={setPage}
							tableCampaignsStatisticsPage={page}
						/>
					)}
				</>
			)}
		</HomeTemplate>
	)
}

export default CampaignsPage
